import { storeApi } from '@shared/config/axios';

export default {
  // Public membership data
  getBySlug(slug, params) {
    const config = params && Object.keys(params).length ? { params } : undefined;
    return storeApi.$get(`/memberships/${slug}`, config);
  },

  // Customer membership management
  getMyMemberships() {
    return storeApi.$get('/customers/me/memberships');
  },

  getMyActiveMemberships() {
    return storeApi.$get('/customers/me/memberships/active');
  },

  getMembershipsWithAccess() {
    return storeApi.$get('/customers/me/memberships/access');
  },

  getAvailablePlans() {
    return storeApi.$get('/customers/me/memberships/available');
  },

  getMembershipDetails(membershipId) {
    return storeApi.$get(`/customers/me/memberships/${membershipId}`);
  },

  // Membership actions
  subscribe(priceUuid, paymentData = {}) {
    return storeApi.$post(`/customers/me/prices/${priceUuid}/subscribe`, paymentData);
  },

  cancelMembership(membershipId) {
    return storeApi.$delete(`/customers/me/memberships/${membershipId}/cancel`);
  },

  resumeMembership(membershipId) {
    return storeApi.$put(`/customers/me/memberships/${membershipId}/resume`);
  },

  retryMembershipPayment(membershipId) {
    return storeApi.$post(`/customers/me/memberships/${membershipId}/payments/retry`);
  },

};
